<p-table class="mdlz-expandable-table" [value]="tableData" [columns]="tableHeader" dataKey="uid"
  [tableStyle]="{ 'min-width': '60rem' }" styleClass="p-datatable-gridlines p-datatable-striped">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 10rem"></th>
      <th *ngFor="let item of tableHeader" [ngClass]="item.header.includes('Q') ? 'th-green' : ''">
        {{ item.header }}
        <span *ngIf="!item.header.includes('Q')" pRipple (click)="onChangeYearExpand(item)"
          [ngClass]="item.isExpanded ? 'fa fa-caret-square-o-left icon-visible' : 'fa fa-caret-square-o-right icon-hide'"
          class="expand-icon"></span>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
    <tr>
      <td>
        <span [ngClass]="rowData.level == 2 ? 'ms-3' : ''">{{ rowData.code }}</span>

        <span *ngIf="rowData.isExpanded" pButton pRipple [pRowToggler]="rowData" class="p-button-text"
          [icon]="expanded ? 'pi pi-minus' : 'pi pi-plus'"></span>
      </td>
      <td *ngFor="let col of columns">{{ rowData[col.field] | number : '1.0-1' : 'en-US' }}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex" let-columns="columns">
    <tr *ngFor="let plant of rowData.plants">
      <td class="ps-5" [title]="plant.code"><span class='plant-code'>{{ plant.code }}</span></td>
      <td *ngFor="let col of columns" class="justify-content-center">{{ plant[col.field] | number : '1.0-1' : 'en-US' }}
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr class="empty-data">
      No Data found.
    </tr>
  </ng-template>
</p-table>
